/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addOrEditAllocationDestination} from '../api'

export const useMutationAddOrEditAllocationDestination = createReactQueryMutationHook('addOrEditAllocationDestination', addOrEditAllocationDestination)
